export { OverlaySingleLegend } from './OverlaySingleLegend.component';
